import Entity from "./entity";
import Glyphs from "../assets/objects/glyphs";
import Description from "./description";
import Mass from "./mass";

class Boat extends Entity {
  willUpdate() {
    return false;
  }

  bumpFrom(entity, stage) {
    if (entity.isPlayer()) {
      this.boardBoat(entity, stage);
    }
  }

  setHeading(direction) {
    this.heading = direction;
  }

  boardBoat(player, stage) {
    player.transport.startSailing(this);
    stage.moveEntityTo(player, this.x, this.y);
    stage.removeEntity(this);
  }

  dockBoat(player, stage) {
    stage.addEntity(this);
    stage.moveEntityTo(this, player.x, player.y);
    player.transport.finishSailing();
  }

  static create() {
    return new Boat(null, null, Glyphs.Boat, "Boat", {
      description: new Description("An old wooden rowboat. Is this seaworthy?"),
      mass: new Mass(Mass.Medium)
    });
  }
}

export default Boat;
